module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_c('cellsTip', [_vm._v("单选项")]), _vm._v(" "), _c('cell', {
    attrs: {
      "radio": ""
    }
  }, [_c('radio', {
    attrs: {
      "forItem": "1r",
      "name": "radio"
    }
  }, [_vm._v("单选1")]), _vm._v(" "), _c('radio', {
    attrs: {
      "forItem": "2r",
      "name": "radio"
    }
  }, [_vm._v("单选2")]), _vm._v(" "), _c('radio', {
    attrs: {
      "forItem": "3r",
      "name": "radio"
    }
  }, [_vm._v("单选3")]), _vm._v(" "), _c('radio', {
    attrs: {
      "forItem": "4r",
      "name": "radio",
      "disabled": ""
    }
  }, [_vm._v("单选4")])]), _vm._v(" "), _c('cellsTip', [_vm._v("复选项")]), _vm._v(" "), _c('cell', {
    attrs: {
      "checkbox": ""
    }
  }, [_c('checkbox', {
    attrs: {
      "forItem": "1c",
      "name": "checkbox"
    }
  }, [_vm._v("复选1")]), _vm._v(" "), _c('checkbox', {
    attrs: {
      "forItem": "2c",
      "name": "checkbox"
    }
  }, [_vm._v("复选2")]), _vm._v(" "), _c('checkbox', {
    attrs: {
      "forItem": "3c",
      "name": "checkbox"
    }
  }, [_vm._v("复选3")]), _vm._v(" "), _c('checkbox', {
    attrs: {
      "forItem": "4c",
      "name": "checkbox",
      "disabled": ""
    }
  }, [_vm._v("复选4")])]), _vm._v(" "), _c('cellsTip', [_vm._v("表单")]), _vm._v(" "), _c('cell', {
    attrs: {
      "form": ""
    }
  }, [_c('vwInput', {
    attrs: {
      "label": "QQ",
      "input-config": "{\n      \"type\": \"tel\",\n      \"placeholder\": \"输入QQ号码\"\n    }"
    }
  }), _vm._v(" "), _c('vwInput', {
    attrs: {
      "label": "手机号",
      "input-config": "{\n      \"type\": \"tel\",\n      \"placeholder\": \"输入手机号码\"\n    }",
      "addon": ""
    }
  }, [_c('addonBtn', {
    slot: "addon"
  }, [_vm._v("获取验证码")])]), _vm._v(" "), _c('vwInput', {
    attrs: {
      "label": "验证码",
      "input-config": "{\n      \"type\": \"tel\",\n      \"placeholder\": \"输入右侧验证码\"\n    }",
      "addon": ""
    }
  }, [_c('addonImg', {
    attrs: {
      "img": "https://imgly.net/img/2gj.jpg"
    },
    slot: "addon"
  })]), _vm._v(" "), _c('vwInput', {
    attrs: {
      "label": "日期",
      "input-config": "{\n      \"type\": \"date\"\n    }"
    }
  }), _vm._v(" "), _c('vwInput', {
    attrs: {
      "label": "时间",
      "input-config": "{\n      \"type\": \"datetime-local\"\n    }"
    }
  }), _vm._v(" "), _c('vwInput', {
    attrs: {
      "warn": "",
      "label": "微信号",
      "input-config": "{\n      \"type\": \"text\",\n      \"placeholder\": \"输入微信号\"\n    }"
    }
  }), _vm._v(" "), _c('vwInput', {
    attrs: {
      "sucess": "",
      "label": "身份证号",
      "input-config": "{\n      \"type\": \"text\",\n      \"placeholder\": \"输入身份证号\"\n    }"
    }
  })]), _vm._v(" "), _c('cellsTip', [_vm._v("开关")]), _vm._v(" "), _c('cell', {
    attrs: {
      "form": ""
    }
  }, [_c('vwInput', {
    attrs: {
      "label": "默认",
      "is-switch": ""
    }
  }, [_c('vwSwitch', {
    slot: "switch"
  })]), _vm._v(" "), _c('vwInput', {
    attrs: {
      "label": "警告",
      "is-switch": ""
    }
  }, [_c('vwSwitch', {
    attrs: {
      "warn": ""
    },
    slot: "switch"
  })])]), _vm._v(" "), _c('cellsTip', [_vm._v("文本域")]), _vm._v(" "), _c('cell', {
    attrs: {
      "form": ""
    }
  }, [_c('vwTextarea', {
    attrs: {
      "addon": "0/200"
    }
  })]), _vm._v(" "), _c('cellsTip', [_vm._v("选择-前置")]), _vm._v(" "), _c('cell', {
    attrs: {
      "form": ""
    }
  }, [_c('vwInput', {
    attrs: {
      "select-before": "",
      "input-config": "{\n      \"type\": \"number\",\n      \"placeholder\": \"输入手机号码\"\n    }"
    }
  }, [_c('vwSelect', {
    attrs: {
      "name": "select1",
      "value": "+87"
    },
    slot: "selector-before"
  }, [_c('option', {
    attrs: {
      "value": "+86"
    }
  }, [_vm._v("+86")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "+80"
    }
  }, [_vm._v("+80")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "+84"
    }
  }, [_vm._v("+84")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "+87"
    }
  }, [_vm._v("+87")])])])]), _vm._v(" "), _c('cellsTip', [_vm._v("选择-默认")]), _vm._v(" "), _c('cell', {
    attrs: {
      "form": ""
    }
  }, [_c('vwInput', {
    attrs: {
      "select": "",
      "input-config": "{\n      \"type\": \"number\",\n      \"placeholder\": \"输入手机号码\"\n    }"
    }
  }, [_c('vwSelect', {
    attrs: {
      "name": "select2",
      "value": "QQ号"
    },
    slot: "selector"
  }, [_c('option', {
    attrs: {
      "value": "微信号"
    }
  }, [_vm._v("微信号")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "QQ号"
    }
  }, [_vm._v("QQ号")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Email"
    }
  }, [_vm._v("Email")])])])]), _vm._v(" "), _c('cellsTip', [_vm._v("选择-后置")]), _vm._v(" "), _c('cell', {
    attrs: {
      "form": ""
    }
  }, [_c('vwInput', {
    attrs: {
      "label": "国家地区",
      "select-after": ""
    }
  }, [_c('vwSelect', {
    attrs: {
      "name": "select3",
      "value": "中国"
    },
    slot: "selector-after"
  }, [_c('option', {
    attrs: {
      "value": "中国"
    }
  }, [_vm._v("中国")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "美国"
    }
  }, [_vm._v("美国")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "英国"
    }
  }, [_vm._v("英国")])])])]), _vm._v(" "), _c('cellsTip', [_vm._v("滑块")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.rangeValA))]), _vm._v(" "), _c('range', {
    on: {
      "on-change": _vm.rangeValForA
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.rangeValB))]), _vm._v(" "), _c('range', {
    attrs: {
      "step": "10",
      "value": _vm.rangeValB
    },
    on: {
      "on-change": _vm.rangeValForB
    }
  })]), _vm._v(" "), _c('cellsTip', [_vm._v("数字")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('number')]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('number', {
    attrs: {
      "value": "10"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('number', {
    attrs: {
      "value": "20",
      "step": "5"
    }
  })]), _vm._v(" "), _c('agree', {
    attrs: {
      "text": "Read and agree",
      "link": "form",
      "title": "《Agreement》"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-9c1dae36!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/formView.vue
// module id = 279
// module chunks = 0